import { Box, IconButton, Switch, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import DrawerBottom from "../../../ui/DrawerBottom";

interface ExcludeFromReportToggleProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const ExcludeFromReportToggle = ({
  label,
  checked,
  onChange,
}: ExcludeFromReportToggleProps) => {
  const { t } = useTranslation(['transactions']);
  const [infoDrawerOpen, setInfoDrawerOpen] = useState(false);

  return (
    <>
      <Box display='flex' alignItems='center' justifyContent='space-between'>
        <Box display='flex' alignItems='center' gap={0.5}>
          <Typography>{label}</Typography>
          <IconButton
            size="small"
            onClick={() => setInfoDrawerOpen(true)}
            sx={{ p: 0, ml: 0.5, color: 'text.secondary', fontSize: '14px' }}
          >
            &#9432;
          </IconButton>
        </Box>
        <Switch
          checked={checked}
          onChange={(event) => onChange(event.target.checked)}
        />
      </Box>

      <DrawerBottom
        open={infoDrawerOpen}
        onClose={() => setInfoDrawerOpen(false)}
        title={t('details.nonreportable_info_title')}
        height="auto"
      >
        <Typography>
          {t('details.nonreportable_info_description')}
        </Typography>
      </DrawerBottom>
    </>
  );
};

export default ExcludeFromReportToggle;
